"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/DMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_62)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_62`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 7.76843V16.1895H30V7.76843H-6Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 7.76843H30V10.5755H-6V7.76843Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 13.3824H30V16.1895H-6V13.3824Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.75439 0H16.1754V24H7.75439V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.75439 0H10.5614V24H7.75439V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.2772 0H16.0842V24H13.2772V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 20.6175C16.7359 20.6175 20.6035 16.7499 20.6035 11.9789C20.6035 7.20796 16.7359 3.34033 11.9649 3.34033C7.19393 3.34033 3.32629 7.20796 3.32629 11.9789C3.32629 16.7499 7.19393 20.6175 11.9649 20.6175Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.965 4.1123L12.2878 5.1088H13.3404L12.4913 5.73336L12.8141 6.72985L11.965 6.1123L11.1158 6.72985L11.4386 5.73336L10.5895 5.1088H11.6421L11.965 4.1123ZM7.34039 5.61406L8.19653 6.2316L9.04566 5.61406L8.72285 6.61757L9.57197 7.23511H8.51934L8.19653 8.2316L7.86671 7.23511H6.81408L7.6632 6.61757L7.34039 5.61406ZM4.48425 9.54388H5.53688L5.85969 8.54739L6.18952 9.54388H7.24215L6.38601 10.1614L6.71583 11.1649L5.85969 10.5474L5.01057 11.1649L5.33338 10.1614L4.48425 9.54388ZM4.48425 14.407L5.33338 13.7895L5.01057 12.786L5.85969 13.4035L6.71583 12.786L6.38601 13.7895L7.24215 14.407H6.18952L5.85969 15.4106L5.53688 14.407H4.48425ZM7.34039 18.3439L7.6632 17.3404L6.81408 16.7228H7.86671L8.19653 15.7193L8.51934 16.7228H9.57197L8.72285 17.3404L9.04566 18.3439L8.19653 17.7193L7.34039 18.3439ZM11.965 19.8456L11.6421 18.8421H10.5895L11.4386 18.2246L11.1158 17.2211L11.965 17.8386L12.8141 17.2211L12.4913 18.2246L13.3404 18.8421H12.2878L11.965 19.8456ZM16.5895 18.3439L15.7334 17.7193L14.8843 18.3439L15.2071 17.3404L14.3579 16.7228H15.4106L15.7334 15.7193L16.0632 16.7228H17.1158L16.2667 17.3404L16.5895 18.3439ZM19.4457 14.407H18.393L18.0702 15.4106L17.7404 14.407H16.6878L17.5439 13.7895L17.2141 12.786L18.0702 13.4035L18.9193 12.786L18.5965 13.7895L19.4457 14.407ZM19.4457 9.54388L18.5965 10.1614L18.9193 11.1649L18.0702 10.5474L17.2141 11.1649L17.5439 10.1614L16.6878 9.54388H17.7404L18.0702 8.54739L18.393 9.54388H19.4457ZM16.5895 5.61406L16.2667 6.61757L17.1158 7.23511H16.0632L15.7334 8.2316L15.4106 7.23511H14.3579L15.2071 6.61757L14.8843 5.61406L15.7334 6.2316L16.5895 5.61406Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.6001 11.8386C12.8281 10.3579 12.5825 10.0772 12.5825 10.0772C12.5825 10.0772 12.6106 9.39646 12.6106 8.98243C12.6106 8.36489 12.0913 7.87366 11.4527 7.87366C10.8492 7.87366 10.3509 8.07717 10.2948 8.64559C10.0001 8.70874 9.69128 8.93331 9.69128 9.39646C9.69128 9.73331 9.76146 9.90875 10.0562 10.0491C10.2036 9.72629 10.358 9.71225 10.7088 9.59997C10.765 9.64208 10.8281 9.8105 10.8913 9.83857L10.9123 9.90875C10.9123 9.90875 9.979 10.3719 9.979 12.0772C9.979 14.1473 11.5229 15.2631 11.5229 15.2631L11.3965 15.2842L11.2632 15.7824H12.8071V15.2772L13.579 16.5052C13.6001 16.4842 14.2948 13.1649 13.6001 11.8386Z",
					fill: "#496E2D"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_62`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as DMFlag };
